import style from './AccountBalances.module.css';
import { colors } from '../../../../colorVars';
import { fields } from './fieldList';
import { Body3 } from '../../../atomic/text/Text';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useWebsocketStore } from '../../../../stores/websocketStore/websocketProvider';
import ApplyRounding from '../../../../utils/math/ApplyRounding';
import { EditableTableField } from '../../../atomic/inputs/editableTableField/EditableTableField';
import { modifyNickname } from '../../../../stores/websocketStore/utils/outgoingMessages/acctbalance/modifyNickname';
import TextButton from '../../../atomic/buttons/textButton/TextButton';
import { resetSimAccount } from '../../../../stores/websocketStore/utils/outgoingMessages/acctbalance/resetSimAccount';

export const AccountBalancesTable = observer(() => {
  const { accountBalanceStore } = useWebsocketStore();
  const balances = accountBalanceStore.balances;
  return (
    <div className={style.container}>
      <table className={style.table}>
        <thead>
          <tr>
            {fields.map((field) => (
              <th key={field.headerName}>
                <Body3 color={colors.lightGrey} fontWeight={700}>
                  {field.headerName}
                </Body3>
              </th>
            ))}
          </tr>
        </thead>
        <tbody className={style.tbody}>
          {Object.keys(balances).map((account) => {
            const row = balances[account];
            const accountType = row.account_type;
            let optionBuyingPower = 'NA';
            let stockBuyingPower = 'NA';
            if (accountType === 'margin') {
              if (row.margin !== undefined) {
                optionBuyingPower = ApplyRounding(
                  row.margin.option_buying_power,
                  2
                );
                stockBuyingPower = ApplyRounding(
                  row.margin.stock_buying_power,
                  2
                );
              }
            } else if (accountType === 'cash') {
              if (row.cash !== undefined && row.cash !== null) {
                optionBuyingPower = ApplyRounding(row.cash.cash_available, 2);
                stockBuyingPower = ApplyRounding(row.cash.cash_available, 2);
              }
            } else if (accountType === 'pdt') {
              optionBuyingPower = ApplyRounding(row.pdt.option_buying_power, 2);
              stockBuyingPower = ApplyRounding(row.pdt.stock_buying_power, 2);
            }
            return (
              <tr key={row.nickname}>
                <td>
                  <EditableTableField
                    backgroundColor="inherit"
                    initialValue={row.nickname}
                    color={colors.lightGrey}
                    updateValue={(value) => {
                      modifyNickname(row.account_number, value);
                    }}
                  />
                </td>
                <td>
                  <Body3 color={colors.white} fontWeight={500}>
                    {row.account_number}
                  </Body3>
                  {row.account_number === 'BACKTEST' ? (
                    <TextButton
                      title="Reset Balance"
                      width="fit-content"
                      lineHeight="0.25rem"
                      clickHandler={resetSimAccount}
                      backgroundColor={colors.red}
                      fontSize="small"
                      color={colors.lightGrey}
                      margin="0 0 0 3px"
                    >
                      R
                    </TextButton>
                  ) : null}
                </td>
                <td>
                  <Body3 color={colors.white} fontWeight={500}>
                    {ApplyRounding(row.total_equity, 2)}
                  </Body3>
                </td>
                <td>
                  <Body3 color={colors.white} fontWeight={500}>
                    {isNaN(ApplyRounding(row.total_cash, 2))
                      ? 'NA'
                      : ApplyRounding(row.total_cash, 2)}
                  </Body3>
                </td>
                <td>
                  <Body3 color={colors.white} fontWeight={500}>
                    {isNaN(ApplyRounding(row.open_pl, 2))
                      ? '0.00'
                      : ApplyRounding(row.open_pl, 2)}
                  </Body3>
                </td>
                <td>
                  <Body3 color={colors.white} fontWeight={500}>
                    {ApplyRounding(row.close_pl, 2)}
                  </Body3>
                </td>
                <td>
                  <Body3 color={colors.white} fontWeight={500}>
                    {optionBuyingPower}
                  </Body3>
                </td>
                <td>
                  <Body3 color={colors.white} fontWeight={500}>
                    {stockBuyingPower}
                  </Body3>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
});
